import React, { useEffect, useState } from "react";

/**Import Styles and Assets */
import styles from "./PostManagement.module.scss";
import back from "./images/back.svg"

import { useUserDonateListing, useUserDonateHeader } from "../../schemas/tableHeaderSchema";
import TableLayout from "../../components/TableLayout";
import { useDispatch, useSelector } from "react-redux";
import { fetchDonateHistoryThunk } from "../../features/DonateReducer";
import { Select } from 'antd';


export default function DonateHistory() {

    const { data, status } = useSelector(state => state.donateHistory);
    const { search } = useSelector(state => state.search);
    const [list, setList] = useState(data);
    const dispatch = useDispatch();

    const [isListed, setIsListed] = useState(true);
    const [showDonate, setShowDonate] = useState('sent');


    const [userDonateList, setUserDonateList] = useState([])
    const [donateList, setDonateList] = useState(userDonateList);



    const userDonateHeader = useUserDonateHeader(setIsListed, setUserDonateList);
    const listingHeader = useUserDonateListing();

    useEffect(() => {
        if (status !== "success") {
            dispatch(fetchDonateHistoryThunk());
        }
    }, [])

    useEffect(() => {
        if (!search) return setList(data);

        const array = [
            ...data.map(item => {
                if (item.name.toLowerCase().includes(search.toLowerCase())) {
                    return item
                }
            })
        ].filter(Boolean)
        setList(array);

    }, [data, search])

    useEffect(() => {
        if (!search) return setDonateList(userDonateList);

        if (!userDonateList.length) return;


        const array = userDonateList[showDonate].filter((item, i) => {
            if (item.donatedBy_name.toLowerCase().includes(search.toLowerCase()) || item.donatedTo_name.toLowerCase().includes(search.toLowerCase())) {
                return item
            }
        })

        setDonateList({
            ...userDonateList,
            [showDonate]: array
        });

    }, [search, userDonateList])



    return isListed ?
        <div className={styles.postManagement} >
            <h1 className={styles.contentTitle}>Donate History</h1>
            <div className={styles.content}>
                <TableLayout headers={userDonateHeader} data={list} status={status} />
            </div>
        </div > :
        <div className={styles.postManagement} >
            <div className={styles.headerContainer}>
                <div className={styles.backButton} onClick={() => setIsListed(true)}>
                    <img src={back} alt="<" />
                    <h1 className={styles.backButton} >Back</h1>
                </div>
                <Select
                    className={styles.select}
                    style={{ width: 200 }}
                    value={showDonate}
                    onChange={(e) => setShowDonate(e)}
                    options={[
                        {
                            value: 'sent',
                            label: 'Sent',
                        },
                        {
                            value: 'recieved',
                            label: 'Recieved',
                        },

                    ]}
                />
            </div>
            <div className={styles.content}>
                <TableLayout headers={listingHeader} data={donateList[showDonate]} status={"success"} />
            </div>
        </div >





}